import React, {
    useState
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import AuditLogRepository from "../../../repositories/AuditLogRepository";
import { EventDateColumnType } from "../../../components/Grid/Columns";
import {useNavigate} from "react-router";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {FilterBar} from "../../../components/Grid/FilterBar";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";
import { saveAs } from 'file-saver'

const AuditLogListView = () => {

	const navigate = useNavigate();
	const repository = new AuditLogRepository();
	const {t}  = useTranslation();
	const [blockedWindow, setBlockedWindow] = useState(false);

	const sortOptions = [
      {
        value: 'Id|desc',
        label: t('Newest first')
      },
      {
        value: 'Id|asc',
        label: t('Oldest first')
      }
    ];

    const handleEditItemClick = (event) => {
    }

	const {items, totalCount, itemsOnPage, onDeleteHandler, onEditHandler, onPage, isSearching, onFilterChangedHandler, onSortChangedHandler, filter, sort, updateGrid } = useGrid(repository, { onEdit: handleEditItemClick, defaultSort: sortOptions[0].value });

	const columns = [
      { field: 'EventDate', type: "dateTime",  headerName: t('Event date'), ... EventDateColumnType },
      { field: 'EntityId', headerName: t('Event ID'), width: 130, sortable: false },
      { field: 'EventType', headerName: t('Event type'), width: 200, sortable: false },
      { field: 'OldValue', headerName: t('Old value'), width: 200, sortable: false },
      { field: 'NewValue', headerName: t('New value'), width: 200, sortable: false },
      { field: 'UserName', headerName: t('User'), width: 150, sortable: false }
    ];

    const handleOnDownload = async (e) => {
	    setBlockedWindow(true);
	    try {
            const response = await repository.export(Object.assign({}, filter, { sort: sort }));
            saveAs(response.data, 'events.csv');
        } catch (e) {
        } finally {
            setBlockedWindow(false);
        }
    }

	return (
	    <GridSkeleton title={t("Audit log")}
                      isSearching={isSearching}
                      header={(<Header onRefresh={updateGrid} onDownload={handleOnDownload}/>)}
                      filter={(<FilterBar sortOptions={sortOptions} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort} />)}
                      grid={(<DataGrid
                                   disableMultipleSelection={true}
                                   disableColumnFilter
                                   rows={items()}
                                   rowCount={totalCount()}
                                   columns={columns}
                                   pageSize={itemsOnPage}
                                   paginationMode="server"
                                   sortingMode="server"
                                   disableColumnSelector={true}
                                   disableSelectionOnClick={true}
                                   disableColumnMenu={true}
                                   onPageChange={onPage}
                                   rowsPerPageOptions={[itemsOnPage]}
                                   hideFooterSelectedRowCount={true}
                         />)}
        />

	);
};

export default AuditLogListView;
